import type { AppState } from '../model';
import type { SessionState } from './sessionModel';

export function getSessionState(state: AppState): SessionState {
  return state.session;
}
